import { collectCss } from '../../../../../../internal/style-injector/src/index.mjs';

var css$1 = ".OTPEntry_module_progressInner__6b10f31d{padding-top:var(--st-spacing-2)}";
collectCss(css$1);
var modules_929e05ad = {"progressInner":"OTPEntry_module_progressInner__6b10f31d"};

export { css$1 as css, modules_929e05ad as default };
//# sourceMappingURL=OTPEntry.module.css.mjs.map
